/**
 * @fileoverview UI state store
 * @description Zustand store for UI-only state (sidebar, modals, etc.)
 * @module stores/ui
 */

import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  activeClientId: string | null;
  inviteModalOpen: boolean;
  assessmentModalOpen: boolean;
}

interface UIActions {
  setSidebarOpen: (open: boolean) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setActiveClientId: (id: string | null) => void;
  setInviteModalOpen: (open: boolean) => void;
  setAssessmentModalOpen: (open: boolean) => void;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState & UIActions>((set) => ({
  // State
  sidebarOpen: true,
  sidebarCollapsed: false,
  activeClientId: null,
  inviteModalOpen: false,
  assessmentModalOpen: false,

  // Actions
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
  setActiveClientId: (id) => set({ activeClientId: id }),
  setInviteModalOpen: (open) => set({ inviteModalOpen: open }),
  setAssessmentModalOpen: (open) => set({ assessmentModalOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
}));
